import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";

//Old One
// const firebaseConfig = {
//   apiKey: "AIzaSyCaTGcvZSl6_9gmn9vYeNhm1QYBHeHKxKs",
//   authDomain: "yingyang-herbs.firebaseapp.com",
//   projectId: "yingyang-herbs",
//   storageBucket: "yingyang-herbs.firebasestorage.app",
//   messagingSenderId: "1093932445815",
//   appId: "1:1093932445815:web:dc54f2da9b952e2c0cd672",
//   measurementId: "G-Q1RCCGPQYH",
// };

// New One
const firebaseConfig = {
  apiKey: "AIzaSyCRd0HwefclHWNBCU_uiKqpkqY1P_1zjkg",
  authDomain: "huashen-herbs.firebaseapp.com",
  projectId: "huashen-herbs",
  storageBucket: "huashen-herbs.firebasestorage.app",
  messagingSenderId: "662770722752",
  appId: "1:662770722752:web:0f607c17f8d8894bd54a25",
  measurementId: "G-9MF3SZM277",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const auth = getAuth(app);
